{
  "hint": "Vul 4 karakters in",
  "label": "Controle deel {stub}",
  "signature_correct": "Digitale handtekening klopt",
  "title": "Controleer digitale vingerafdruk"
}
